export const weight_regular = "400";
export const weight_semi_bold = "600";
export const weight_bold = "700";
export const weight_black = "900";
